'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPower = function IoPower(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 20c-1.4 0-2.5-1.1-2.5-2.5v-12.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v12.5c0 1.4-1.1 2.5-2.5 2.5z m9.6-14.6c4.8 3.1 7.9 8.5 7.9 14.6 0 9.7-7.8 17.5-17.5 17.5s-17.5-7.8-17.5-17.5c0-6.1 3.1-11.5 7.9-14.6 0.4-0.2 0.9-0.4 1.3-0.4 1.4 0 2.5 1.1 2.5 2.5 0 0.5-0.1 0.9-0.4 1.3-0.1 0.3-0.3 0.5-0.5 0.7-0.1 0-0.3 0.1-0.3 0.2-0.7 0.5-1.3 0.9-1.8 1.5-2.4 2.3-3.7 5.4-3.7 8.8s1.3 6.5 3.7 8.8 5.4 3.7 8.8 3.7 6.5-1.3 8.8-3.7 3.7-5.4 3.7-8.8-1.3-6.5-3.7-8.8c-0.5-0.6-1.1-1-1.8-1.5 0-0.1-0.2-0.2-0.3-0.2-0.2-0.2-0.4-0.4-0.5-0.7-0.3-0.4-0.4-0.8-0.4-1.3 0-1.4 1.1-2.5 2.5-2.5 0.4 0 0.9 0.2 1.3 0.4z' })
        )
    );
};

exports.default = IoPower;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/power.js
// module id = 2872
// module chunks = 168707334958949